/* Spacezat · comportamiento de la capa de marca
   - Compra mínima de $238.000 (barra de avance y bloqueo del botón de pago)
   - Precios con punto de miles (1.234.567)
   - Traducciones de etiquetas de filtros
   - Sombra del encabezado y aparición suave de secciones */
(function () {
  if (window.__sz) return;
  window.__sz = true;

  var MIN = 238000;
  function money(n) { return '$' + Math.round(n).toLocaleString('es-CL'); }
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ---- precios: 1,234 -> 1.234 ---- */
  var PRICE = /(\$\s?\d{1,3}(?:,\d{3})+)/g;
  function fixText(root) {
    if (!root || root.nodeType === 8) return;
    var w = document.createTreeWalker(root.nodeType === 3 ? root.parentNode : root, NodeFilter.SHOW_TEXT, null), n, list = [];
    while ((n = w.nextNode())) { if (/\$\s?\d{1,3},\d{3}/.test(n.nodeValue)) list.push(n); }
    list.forEach(function (t) {
      var p = t.parentNode && t.parentNode.nodeName;
      if (p === 'SCRIPT' || p === 'STYLE' || p === 'TEXTAREA') return;
      t.nodeValue = t.nodeValue.replace(PRICE, function (m) { return m.replace(/,/g, '.'); });
    });
  }

  /* ---- etiquetas de filtros en español ---- */
  var TR = { 'Availability': 'Disponibilidad', 'Price': 'Precio', 'Filter': 'Filtro', 'Sort': 'Ordenar' };
  function translate(root) {
    $$('.cc-filter__toggle, .cc-filter-heading', root).forEach(function (el) {
      var t = el.textContent.trim();
      if (TR[t] && el.children.length === 0) el.textContent = TR[t];
    });
  }

  /* ---- avisos con emoji -> icono ---- */
  var ICON = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9.5"/><path d="M12 11v5.5M12 7.6v.1"/></svg>';
  function notices() {
    $$('.cart div[style*="ffe6f0"]').forEach(function (el) {
      if (el.getAttribute('data-sz')) return;
      el.setAttribute('data-sz', '1');
      el.innerHTML = el.innerHTML.replace(/🚨\s*/g, '').replace(/^\s+/, '');
      el.insertAdjacentHTML('afterbegin', ICON);
      var wrap = document.createElement('div'); wrap.style.minWidth = '0';
      while (el.childNodes.length > 1) wrap.appendChild(el.childNodes[1]);
      el.appendChild(wrap);
    });
  }

  /* ---- compra mínima ---- */
  var below = false, box = null, form = null;
  function ensureBox() {
    if (box && document.body.contains(box)) return box;
    form = $('.cart form[action$="/cart"]');
    if (!form) return null;
    var anchor = $('.cart-finish', form) || form.lastElementChild;
    box = document.createElement('div');
    box.className = 'sz-minorder';
    box.setAttribute('role', 'status');
    box.innerHTML = '<div class="sz-minorder__row"><b>Compra mínima ' + money(MIN) + '</b><span data-sz-left></span></div><div class="sz-minorder__bar"><i></i></div>';
    anchor.parentNode.insertBefore(box, anchor);
    return box;
  }
  function render(total) {
    var b = ensureBox();
    if (!b) return;
    below = total < MIN;
    var pct = Math.max(0, Math.min(100, Math.round(total / MIN * 100)));
    $('i', b).style.width = pct + '%';
    $('[data-sz-left]', b).textContent = below ? 'Te faltan ' + money(MIN - total) : 'Compra mínima alcanzada';
    b.classList.toggle('is-ok', !below);
    var cart = $('.cart');
    if (cart) cart.classList.toggle('is-below-min', below);
    $$('input[name="checkout"], button[name="checkout"], .cart-submit', form).forEach(function (btn) {
      btn.disabled = below;
      btn.setAttribute('aria-disabled', below ? 'true' : 'false');
    });
  }
  function refresh() {
    if (!$('.cart form[action$="/cart"]')) return;
    fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (c) { render(c.total_price / 100); }).catch(function () {});
  }
  document.addEventListener('submit', function (e) {
    if (!below) return;
    var f = e.target;
    if (!f || !f.matches || !f.matches('.cart form[action$="/cart"]')) return;
    var s = e.submitter;
    if (s && s.name === 'checkout') {
      e.preventDefault(); e.stopImmediatePropagation();
      if (box) { box.classList.remove('is-shake'); void box.offsetWidth; box.classList.add('is-shake'); }
    }
  }, true);
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="/checkout"]');
    if (a && below) { e.preventDefault(); if (box) { box.classList.remove('is-shake'); void box.offsetWidth; box.classList.add('is-shake'); } }
  }, true);

  /* ---- sombra de cabecera ---- */
  function onScroll() { document.documentElement.classList.toggle('sz-scrolled', window.pageYOffset > 8); }
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ---- aparición suave ---- */
  function reveal() {
    var els = $$('.sz-reveal:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
    els.forEach(function (e) { io.observe(e); });
  }

  var t = null;
  function pass(n) { fixText(n || document.body); translate(document); notices(); }
  function init() {
    onScroll(); pass(); reveal(); refresh();
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { pass(); if ($('.cart form[action$="/cart"]')) refresh(); }, 120);
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
    setInterval(refresh, 4000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
